fragment SupplierControlPanelGroupedTranslatorFragment on SupplierControlPanelGroupedTranslator {
    id
    supplier_id
    updated
    has_empty_columns
    field_name
    code
    original_text_en
    original_text_sv
    translations
    original_print_color
    print_color
}